import {
  GET_CHAT_AGENTS,
  SAVE_CHAT_AGENTS,
  GET_CHAT_GROUPS,
  SAVE_CHAT_GROUPS,
  SAVE_CHAT_ASSIGNMENT_RULES,
  GET_ALL_CHAT_ASSIGNMENT_RULES,
  SEND_CHAT_ASSIGNMENT_RULES,
  UPDATE_CHAT_ASSIGNMENT_RULES,
  SAVE_ALL_CHAT_ASSIGNMENT_RULES,
  DELETE_CHAT_ASSIGNMENT_RULE,
  UPDATE_CHAT_ASSIGNMENT_RULE_STATUS,
  RESET_CHAT_ASSIGNMENT,
} from "../constants/ChatAssignment";

export const getChatAgents = () => {
  return {
    type: GET_CHAT_AGENTS,
  };
};

export const resetChatAssignment = () => {
  return {
    type: RESET_CHAT_ASSIGNMENT
  };
};

export const saveChatAgents = (agents) => {
  return {
    type: SAVE_CHAT_AGENTS,
    payload: agents,
  };
};
export const getChatGroups = () => {
  return {
    type: GET_CHAT_GROUPS,
  };
};

export const saveChatGroups = (groups) => {
  return {
    type: SAVE_CHAT_GROUPS,
    payload: groups,
  };
};
export const saveChatAssignmentRules = (rules) => {
  return {
    type: SAVE_CHAT_ASSIGNMENT_RULES,
    payload: rules,
  };
};
export const sendChatAssignmentRules = (rules) => {
  return {
    type: SEND_CHAT_ASSIGNMENT_RULES,
    payload: rules,
  };
};
export const updateChatAssignmentRules = ({ id, rules }) => {
  return {
    type: UPDATE_CHAT_ASSIGNMENT_RULES,
    payload: { id, rules },
  };
};
export const updateChatAssignmentRuleStatus = ({ id, rules }) => {
  return {
    type: UPDATE_CHAT_ASSIGNMENT_RULE_STATUS,
    payload: { id, rules },
  };
};
export const getAllChatAssignmentRules = () => {
  return {
    type: GET_ALL_CHAT_ASSIGNMENT_RULES,
  };
};
export const saveAllChatAssignmentRules = (allRules) => {
  return {
    type: SAVE_ALL_CHAT_ASSIGNMENT_RULES,
    payload: allRules,
  };
};

export const deleteChatAssignmentRule = (ruleId) => {
  return {
    type: DELETE_CHAT_ASSIGNMENT_RULE,
    payload: ruleId,
  };
};
